import * as SliderPrimitive from "@radix-ui/react-slider";

export const Slider = SliderPrimitive;
